import httpClient from '../httpClient';


const getRestaurant =  (page,pagesSize) => httpClient.get(`/Restaurants?page=${1}&pageSize=${1000}`).then(
  (data) => data
)
  .catch((e)=>{
   //
  })
const setRestaurant =  (params) => httpClient.post('/Restaurants', params,{ headers: { Authorization: `Bearer ${localStorage.getItem('lotusToken')}` } })

const putRestaurant = (params,id) => httpClient.put(`/Restaurants/${id}`, params,{ headers: { Authorization: `Bearer ${localStorage.getItem('lotusToken')}` } })


const  deleteRestaurant= (id) => httpClient.delete(`/Restaurants/${id}`,{ headers: { Authorization: `Bearer ${localStorage.getItem('lotusToken')}` } })

export {
  getRestaurant,
  setRestaurant,
  putRestaurant,
  deleteRestaurant,
  // getUser,
  // createUser
}
